// TODO keep in sync with functions/src/config.ts

export interface PlanLimits {
    warning: number;
    stop: number;
}

const DEFAULT_USAGE_LIMITS: PlanLimits = {
    warning: 50,
    stop: 80
};

const PLAN_LIMITS: Record<string, PlanLimits> = {
    'HEAVY': { warning: 50, stop: 80 },
};

export function getPlanLimits(planName?: string): PlanLimits {
    if (!planName) {
        return DEFAULT_USAGE_LIMITS;
    }
    return PLAN_LIMITS[planName] || DEFAULT_USAGE_LIMITS;
};
